import { AuthTranslationType } from "../../features/auth.types";

export const auth: AuthTranslationType = {
  auth: {    
    cookieConsent: {
      title: "موافقة ملف تعريف الارتباط",
      description: "يستخدم هذا الموقع ملفات تعريف الارتباط لتعزيز تجربة التصفح الخاصة بك. بالنقر فوق 'قبول'، فإنك توافق على استخدام ملفات تعريف الارتباط وفقًا لسياسة ملفات تعريف الارتباط الخاصة بنا.",
      accept: "قبول ملفات تعريف الارتباط",
      readMore: "لمعرفة المزيد، يرجى قراءة ",
      privacyPolicy: "سياسة الخصوصية",
      and: "و",
      termsOfService: "شروط الخدمة"
    },
    title: {
      resetPassword: "إعادة تعيين كلمة المرور",
      welcome: "مرحبًا بعودتك"
    },
    form: {
      displayName: "اسم العرض",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      newPassword: "كلمة المرور الجديدة",
      forgotPassword: "نسيت كلمة المرور؟",
      loading: "جار التحميل...",
      signIn: "تسجيل الدخول",
      signUp: "إنشاء حساب",
      resetPassword: "إعادة تعيين كلمة المرور",
      sendResetLink: "إرسال رابط إعادة التعيين",
      alreadyHaveAccount: "لديك حساب بالفعل؟ تسجيل الدخول",
      needAccount: "تحتاج إلى حساب؟ إنشاء حساب",
      backToSignIn: "العودة إلى تسجيل الدخول",
      orContinueWith: "أو المتابعة باستخدام",
      google: "جوجل",
      facebook: "فيسبوك",
      privacyPolicyAgreement: "بالنقر على إنشاء حساب، فإنك توافق على",
      privacyPolicy: "سياسة الخصوصية",
      termsAgreement: "و",
      termsOfService: "شروط الخدمة"
    },
    toast: {
      missingInfo: {
        title: "معلومات مفقودة",
        description: "يرجى تقديم البريد الإلكتروني وكلمة المرور."
      },
      missingName: {
        title: "معلومات مفقودة",
        description: "يرجى تقديم اسم العرض."
      },
      invalidEmail: {
        title: "بريد إلكتروني غير صالح",
        description: "يرجى إدخال عنوان بريد إلكتروني صالح."
      },
      invalidPassword: {
        title: "كلمة مرور غير صالحة",
        description: "يجب أن تكون كلمة المرور 6 أحرف على الأقل."
      },
      emailNotVerified: {
        title: "البريد الإلكتروني غير مُتحقق منه",
        description: "يرجى التحقق من صندوق الوارد الخاص بك والنقر على رابط التأكيد للتحقق من بريدك الإلكتروني. تحتاج إلى رابط جديد؟",
        resend: "إعادة إرسال"
      },
      verificationEmailSent: {
        title: "تم إرسال بريد التحقق",
        description: "يرجى التحقق من صندوق الوارد للحصول على رابط التأكيد."
      },
      loginFailed: {
        title: "فشل تسجيل الدخول",
        description: "بريد إلكتروني أو كلمة مرور غير صالحة. يرجى المحاولة مرة أخرى أو إنشاء حساب إذا لم يكن لديك حساب."
      },
      displayNameTaken: {
        title: "اسم العرض مستخدم",
        description: "اسم العرض هذا قيد الاستخدام بالفعل. يرجى اختيار واحد آخر."
      },
      signUpSuccess: {
        title: "نجاح",
        description: "تحقق من بريدك الإلكتروني للحصول على رابط التأكيد!"
      },
      userAlreadyRegistered: {
        title: "فشل التسجيل",
        description: "هذا البريد الإلكتروني مسجل بالفعل. يرجى محاولة تسجيل الدخول بدلاً من ذلك."
      },
      resetEmailSent: {
        title: "تحقق من بريدك الإلكتروني",
        description: "لقد أرسلنا لك رابطًا لإعادة تعيين كلمة المرور. يرجى التحقق من صندوق الوارد الخاص بك."
      },
      resetSuccess: {
        title: "نجاح",
        description: "تمت إعادة تعيين كلمة المرور بنجاح. يرجى تسجيل الدخول باستخدام كلمة المرور الجديدة."
      },
      error: {
        title: "خطأ",
        description: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى."
      },
      googleLoginError: {
        title: "خطأ في تسجيل الدخول عبر جوجل",
        description: "غير قادر على تسجيل الدخول باستخدام جوجل. يرجى المحاولة مرة أخرى."
      },
      facebookLoginError: {
        title: "خطأ في تسجيل الدخول عبر فيسبوك",
        description: "غير قادر على بدء تسجيل الدخول باستخدام فيسبوك. يرجى المحاولة مرة أخرى."
      },
      samePassword: {
        title: "كلمة المرور نفسها",
        description: "يجب أن تكون كلمة المرور الجديدة مختلفة عن كلمة المرور القديمة."
      },
      agreementRequired: {
        title: "مطلوب الموافقة",
        description: "يجب الموافقة على سياسة الخصوصية وشروط الخدمة."
      }
    }
  }
};
